import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useDiagnosticContext } from '../context/DiagnosticContext';
import styles from './Header.module.css';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { user, profile } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const { resetDiagnostic } = useDiagnosticContext();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleStartDiagnostic = (e: React.MouseEvent) => {
    e.preventDefault();
    closeMenu();
    if (user) {
      resetDiagnostic();
      navigate('/diagnostic');
    } else {
      navigate('/login');
    }
  };

  const isHome = location.pathname === '/';

  return (
    <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
      <nav className={styles.nav}>
        <Link to="/" className={styles.logo} onClick={closeMenu}>
          PCCheckr<span>.com</span>
        </Link>

        <button className={styles.navToggle} onClick={toggleMenu} aria-label="Toggle menu">
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <ul className={`${styles.navLinks} ${isMenuOpen ? styles.open : ''}`}>
          <li><Link to="/#free-checks" onClick={closeMenu}>Free Checks</Link></li>
          <li><Link to="/#how-it-works" onClick={closeMenu}>How It Works</Link></li>
          <li><Link to="/pricing" onClick={closeMenu}>Pricing</Link></li>

          {user ? (
            <>
              <li><Link to="/dashboard" onClick={closeMenu}>Dashboard</Link></li>
              {(profile?.role === 'admin' || profile?.role === 'super_admin' || user?.email === 'sahin.siddique@gmail.com') && (
                <li><Link to="/admin" onClick={closeMenu} style={{ color: 'var(--accent)', fontWeight: 600 }}>Admin</Link></li>
              )}
              <li>
                <div className={styles.navProfileWrap}>
                  <Link to="/dashboard" className={styles.navAuth} onClick={closeMenu}>
                    <User size={18} /> {profile?.displayName?.split(' ')[0] || 'Profile'}
                  </Link>
                  {profile && (
                    <span className={styles.creditsBadge}>
                      {profile.credits || 0} {profile.credits === 1 ? 'Credit' : 'Credits'}
                    </span>
                  )}
                </div>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/login" onClick={closeMenu}>Sign In</Link></li>
              <li><Link to="/login?mode=signup" className={styles.navAuth} onClick={closeMenu}>Create Account</Link></li>
            </>
          )}
          
          <li>
            <button 
              onClick={handleStartDiagnostic} 
              className={styles.navCta}
            >
              {user 
                ? "Run Scan →" 
                : "Get Started →"}
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

